export default __webpack_public_path__ + "1.16.6/static/media/close.b1d40998.svg";